import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { message, Spin } from 'antd';
import styled from 'styled-components';
import { useAuth } from '../contexts/AuthContext';
import { handleApiError } from '../utils/errorHandler';
import en from '../locales/en';

const Container = styled.div`
  min-height: calc(100vh - 64px);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px;
  color: white;
`;

const LoadingText = styled.div`
  margin-top: 20px;
  font-size: 16px;
`;

function GoogleAuthCallback() {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const processedRef = React.useRef(false);

  useEffect(() => {
    const handleCallback = async () => {
      if (processedRef.current) return;
      processedRef.current = true;

      try {
        const params = new URLSearchParams(location.search);
        const code = params.get('code');
        const state = params.get('state');

        if (!code) {
          throw new Error(en.auth.google.noAuthCode);
        }

        let redirectPath = '/';
        let redirectUri = window.location.origin + '/auth/google-login';
        let paramName = 'code';

        if (state) {
          try {
            const stateObj = JSON.parse(state);
            redirectPath = stateObj.from || redirectPath;
            redirectUri = stateObj.redirect_uri || redirectUri;
            paramName = stateObj.paramName || 'code';
          } catch (e) {
            console.error('Failed to parse state parameter:', e);
          }
        }

        console.log('Received Google auth code, sending to server');

        const requestBody = {
          [paramName]: code,
          redirect_uri: redirectUri,
          platform: 'web'
        };

        const response = await fetch('https://api.kalimbaflows.com/auth/google-web-login', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(requestBody),
        });

        const data = await response.json();

        if (!response.ok) {
          throw new Error(data.message || en.auth.google.failed);
        }

        if (data.token) {
          login(data.token);
          message.success(en.auth.google.success);
          navigate(redirectPath, { replace: true });
        } else {
          throw new Error(en.auth.google.noToken);
        }
      } catch (error) {
        console.error('Google login callback error:', error);
        const errorMsg = handleApiError(error, en.auth.google.retryLater);
        setError(errorMsg);
        setTimeout(() => {
          navigate('/login', { replace: true });
        }, 3000);
      } finally {
        setLoading(false);
      }
    };

    handleCallback();

    return () => {
      //processedRef.current = false;
    };
  }, []);

  return (
    <Container>
      {loading ? (
        <>
          <Spin size="large" />
          <LoadingText>{en.auth.google.processing}</LoadingText>
        </>
      ) : error ? (
        <>
          <div style={{ color: '#ff4d4f', marginBottom: '16px', textAlign: 'center' }}>
            {error}
          </div>
          <div>{en.auth.google.returningToLogin}</div>
        </>
      ) : (
        <LoadingText>{en.auth.google.redirecting}</LoadingText>
      )}
    </Container>
  );
}

export default GoogleAuthCallback; 